module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icon/icon-list-d4be337cd3392f11afa2459c6c8921e2.svg&quot;;"